import api from '../api/axios';

const BASE_URL = 'api/appointments';

/**
 * Ottiene la lista di appuntamenti con possibilità di filtri
 * 
 * Parametri possibili:
 * - date_from: data di inizio (formato YYYY-MM-DD)
 * - date_to: data di fine (formato YYYY-MM-DD)
 * - future_only: solo appuntamenti futuri (true/false)
 * - past_only: solo appuntamenti passati (true/false)
 * - participant: id del partecipante
 * - user_filter: 'created' (creati dall'utente), 'participating' (dove è partecipante), 'involved' (entrambi)
 * - date: filtra per data specifica
 * - is_in_office: filtra per appuntamenti in sede
 * - client: filtra per cliente
 * - appointment_type: filtra per tipo di appuntamento ('EVENT', 'MEETING', 'APPOINTMENT')
 */
export const getAppointments = (params = {}) => {
  return api.get(`${BASE_URL}/appointments/`, { params });
};

/**
 * Ottiene un appuntamento specifico per ID
 */
export const getAppointment = (id) => {
  return api.get(`${BASE_URL}/appointments/${id}/`);
};

/**
 * Crea un nuovo appuntamento
 */
export const createAppointment = (data) => {
  return api.post(`${BASE_URL}/appointments/`, data);
};

/**
 * Aggiorna un appuntamento esistente
 */
export const updateAppointment = (id, data) => {
  return api.put(`${BASE_URL}/appointments/${id}/`, data);
};

/**
 * Elimina un appuntamento
 */
export const deleteAppointment = (id) => {
  return api.delete(`${BASE_URL}/appointments/${id}/`);
};

/**
 * Ottiene gli appuntamenti di oggi
 */
export const getTodayAppointments = () => {
  return api.get(`${BASE_URL}/appointments/today/`);
};

/**
 * Ottiene gli appuntamenti futuri
 */
export const getUpcomingAppointments = () => {
  return api.get(`${BASE_URL}/appointments/upcoming/`);
};

/**
 * Ottiene la cronologia di tutti gli appuntamenti (o filtrata)
 */
export const getAppointmentsHistory = (params = {}) => {
  return api.get(`${BASE_URL}/appointment-history/`, { params });
};

/**
 * Ottiene la cronologia di un appuntamento specifico
 */
export const getAppointmentHistory = (appointmentId) => {
  return api.get(`${BASE_URL}/appointment-history/`, { 
    params: { 
      appointment_id: appointmentId 
    } 
  });
}; 